import React, { Suspense } from 'react';
import Container from 'react-bootstrap/Container';
import { Route, Routes } from 'react-router-dom';
import routes from '../../Routes';

// routes config
const FallbackLoader = () => {
  return <Container></Container>;
};

const TheContent = () => (
  <Suspense fallback={<FallbackLoader />}>
    <Container fluid className="p-0">
      <Routes>
        {routes.map(
          (route, idx) =>
            route.component &&
            (Array.isArray(route.path) ? ( // Check if the path is an array
              route.path.map((subRoute, sKey) => (
                <Route
                  key={sKey}
                  path={subRoute}
                  Component={(props) => <route.component {...props} />}
                />
              ))
            ) : (
              <Route
                key={idx}
                path={route.path}
                Component={(props) => <route.component {...props} />}
              />
            )),
        )}
      </Routes>
    </Container>
  </Suspense>
);
export default React.memo(TheContent);
